var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"annexUpload"},[_c('el-upload',{attrs:{"action":_vm.url,"show-file-list":false,"before-upload":_vm.beforeAvatarUpload,"multiple":false,"http-request":_vm.upload,"accept":_vm.accept,"data":_vm.data}},[_vm._t("uploadContent")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }